import { gql, graphql } from "react-apollo"
import type { Sensor } from "../types"

const MUTATE_UPDATE_SENSOR = gql`
  mutation UpdateSensor($id: ID!, $sensor: SensorInput!) {
    updateSensor(id: $id, sensor: $sensor) {
      id
      friendlyName
    }
  }
`

const mutateUpdateSensor = graphql(MUTATE_UPDATE_SENSOR, {
  name: "mutateUpdateSensor",
  props: ({ mutateUpdateSensor }) => ({
    updateSensor: (id: string, { friendlyName }: Sensor) =>
      mutateUpdateSensor({
        variables: { id, sensor: { friendlyName } }
      })
  })
})

export default mutateUpdateSensor



// WEBPACK FOOTER //
// ./src/Sensors/queries/mutateUpdateSensor.js